import { Box, List, ListItemButton, ListItemText } from '@mui/material';

const ChartSelector = ({ selectedChart, setSelectedChart }) => {
    const getItemStyles = (chartKey) => ({
        borderRight: selectedChart === chartKey ? '4px solid #1976d2' : 'none',
        backgroundColor: selectedChart === chartKey ? 'rgba(25, 118, 210, 0.1)' : 'transparent',
        fontWeight: selectedChart === chartKey ? 'bold' : 'normal',
        transition: 'all 0.3s ease',
    });

    return (
        <Box sx={{ width: '100%' }}>
            <List>
                <ListItemButton
                    selected={selectedChart === 'activeUsers'}
                    onClick={() => setSelectedChart('activeUsers')}
                    sx={getItemStyles('activeUsers')}
                >
                    <ListItemText primary="משתמשים פעילים" />
                </ListItemButton>

                <ListItemButton
                    selected={selectedChart === 'requests'}
                    onClick={() => setSelectedChart('requests')}
                    sx={getItemStyles('requests')}
                >
                    <ListItemText primary="קריאות למערכת" />
                </ListItemButton>

                {/* <ListItemButton
                    selected={selectedChart === 'searches'}
                    onClick={() => setSelectedChart('searches')}
                    sx={getItemStyles('searches')}
                >
                    <ListItemText primary="מה אנשים מחפשים" />
                </ListItemButton> */}
            </List>
        </Box>
    );
};

export default ChartSelector;
